import Navbar from "../Navbar.js/Navbar";
import "./Header.css";

function Header() {
    return (
        <>
        <Navbar />
        </>
    );
  }
  
  export default Header;